import type { ReactNode } from "react";
import { HintMark } from "./Tooltip";

export interface FormFieldProps {
  label: string;
  htmlFor?: string;
  error?: string;
  /** Always-visible helper under the control. */
  hint?: string;
  /** Info-mark tooltip on the label (field meaning / option guide). */
  tooltip?: string;
  required?: boolean;
  children: ReactNode;
}

/** Label + control + hint/error, spaced consistently. */
export function FormField({ label, htmlFor, error, hint, tooltip, required, children }: FormFieldProps) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-2)" }}>
      <span style={{ display: "inline-flex", alignItems: "center", gap: "var(--space-1)" }}>
        <label
          htmlFor={htmlFor}
          style={{
            fontSize: "var(--font-size-sm)",
            fontWeight: "var(--font-weight-medium)",
            color: "var(--color-text)",
          }}
        >
          {label}
          {required && <span style={{ color: "var(--color-primary)" }}> *</span>}
        </label>
        {tooltip ? <HintMark label={`About ${label}`} text={tooltip} /> : null}
      </span>
      {children}
      {hint && !error && (
        <span style={{ fontSize: "var(--font-size-xs)", color: "var(--color-text-muted)" }}>{hint}</span>
      )}
      {error && (
        <span style={{ fontSize: "var(--font-size-xs)", color: "var(--color-danger)" }}>{error}</span>
      )}
    </div>
  );
}
